import * as Io5 from "react-icons/io5";

// Ionicons (same icon set as the original app) by their original names, e.g. "sparkles-outline".
const toKey = (name) => "Io" + name.split("-").map((s) => s.charAt(0).toUpperCase() + s.slice(1)).join("");

export const Ion = ({ name, size = 18, color, style, className }) => {
  const C = Io5[toKey(name)] || Io5.IoEllipseOutline;
  return <C size={size} color={color} style={style} className={className} aria-hidden="true" />;
};
